import { NgModule } from '@angular/core';
import { GridModule,ExcelModule } from '@progress/kendo-angular-grid';
import { DropDownsModule, DropDownListModule } from '@progress/kendo-angular-dropdowns'
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { TelerikReportingModule } from '@progress/telerik-angular-report-viewer';
import { PopupModule } from '@progress/kendo-angular-popup';

const kendoModules: any[] = [
    GridModule,
    DropDownsModule,
    UploadModule,
    ExcelModule,
    DateInputsModule,
    TelerikReportingModule,
    PopupModule
];

@NgModule({
    imports: kendoModules,
    exports: kendoModules
})

export class KendoModule { }
